exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".size-picker-drop {\n  position: fixed;\n  width: 288px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/reservation-change-provider/reservation-change-provider.component.scss
// module id = 2132
// module chunks = 66